/**
 * Analytics hooks for /connect/mcp (MCP OAuth consent).
 *
 * Inert: the app no longer runs Trodo's browser SDK on itself, so nothing is
 * identified, grouped or tracked here. The exports stay so the consent page's
 * calls keep working unchanged.
 */

/** On consent page load. */
export async function mcpOauthConnectPageView() {}

/** When the user picks a team. */
export async function mcpOauthTeamContext() {}

/** When the user submits Allow or Cancel. */
export async function mcpOauthConsentEvent() {}
